"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const clsx = require("../../../chunks/clsx-CBkIpawf.js");
const foundations_typography_Text_Text = require("../../../foundations/typography/Text/Text.js");
const components_overlay_Modal_components_ModalContainer = require("../Modal/components/ModalContainer.js");
const components_overlay_Modal_components_ModalHeader = require("../Modal/components/ModalHeader.js");
const components_overlay_Modal_Modal = require("../Modal/Modal.js");
const drawer = "_drawer_1p2s7_3";
const drawerHeader = "_drawerHeader_1p2s7_23";
const drawerContainer = "_drawerContainer_1p2s7_36";
const drawerOverlayEntering = "_drawerOverlayEntering_1p2s7_45";
const drawerOverlayExiting = "_drawerOverlayExiting_1p2s7_49";
const drawerEntering = "_drawerEntering_1p2s7_54";
const drawerExiting = "_drawerExiting_1p2s7_62";
const styles = {
  drawer,
  drawerHeader,
  drawerContainer,
  drawerOverlayEntering,
  drawerOverlayExiting,
  drawerEntering,
  drawerExiting
};
const Drawer = ({
  children,
  closeButtonDescription,
  isDialog = false,
  isOpen,
  onClose,
  renderIn,
  restoreFocus = true,
  shouldMount = false,
  title,
  ...props
}) => {
  return /* @__PURE__ */ jsxRuntime.jsx(
    components_overlay_Modal_Modal.Modal,
    {
      animationTimeout: 600,
      closeOnBlurOutside: !isDialog,
      focusTrap: isDialog,
      isOpen,
      onClose,
      renderIn,
      restoreFocus,
      shouldMount,
      title,
      transitionStyles: {
        entering: styles.drawerOverlayEntering,
        exiting: styles.drawerOverlayExiting
      },
      children: /* @__PURE__ */ jsxRuntime.jsxs(
        components_overlay_Modal_components_ModalContainer.ModalContainer,
        {
          "aria-label": title,
          component: isDialog ? "div" : "aside",
          className: clsx.clsx(styles.drawer, props.className),
          role: isDialog ? "dialog" : void 0,
          transitionStyles: {
            entering: styles.drawerEntering,
            exiting: styles.drawerExiting
          },
          ...props,
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(
              components_overlay_Modal_components_ModalHeader.ModalHeader,
              {
                closeButtonDescription,
                className: styles.drawerHeader,
                children: title
              }
            ),
            /* @__PURE__ */ jsxRuntime.jsx("div", { className: styles.drawerContainer, children: typeof children === "string" ? /* @__PURE__ */ jsxRuntime.jsx(foundations_typography_Text_Text.Text, { children }) : /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, { children }) })
          ]
        }
      )
    }
  );
};
exports.Drawer = Drawer;
